var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "156px",
    height: "98px",
    viewBox: "0 0 156 98",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "94.5123255%",
    y1: "55.771339%",
    x2: "19.6413923%",
    y2: "42.2391963%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2CB5D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62EBB9",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5,56.4063055 C7.16181688,53.4384236 10.6502032,51.9544827 15.465159,51.9544827 C22.6875927,51.9544827 40.522582,49.3469865 49.0715851,45.3085473 C57.6205882,41.2701081 82.9728044,29.6953689 87.984289,23.7596052 C92.9957736,17.8238415 94.1749464,14.5743914 95.7963091,15.1603578 C97.4176717,15.7463242 96.3858955,17.8238415 95.7963091,19.9013588 C95.2067226,21.9788761 94.4697396,27.3210634 97.2702751,28.211428 C100.070811,29.1017925 102.134363,37.9691599 112.746919,35.0375562 C123.359474,32.1059525 126.307406,24.1849532 129.402735,25.2435461 C132.498064,26.302139 147.270914,40.8546212 144.028188,61.0362177 C141.866371,74.4906154 96.1749779,76.3900892 6.9540076,66.7346392 L5,56.4063055 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.3981453,61.2292859 C86.6015166,45.0720333 100.788066,39.4868102 123.957795,44.4736165 C125.37645,44.8463242 128.923087,43.0086483 127.930029,43.0086483 C124.960366,41.6409621 68.6323662,28.8195138 62.9577462,65.503102 C63.5355292,68.1148786 69.6823288,66.6902732 81.3981453,61.2292859 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.8%",
    y: "-1.8%",
    width: "101.5%",
    height: "107.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.25 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "81.7993164%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F8F8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HH---Complete-the-assessments-and-reveal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Employer-Dashboard-LG-03.7.0-Copy-3",
    transform: "translate(-565.000000, -1152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(458.000000, 1062.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(107.283809, 90.530214)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "url(#linearGradient-1)",
    transform: "translate(74.745216, 43.939251) rotate(-13.000000) translate(-74.745216, -43.939251) ",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path-38",
    transform: "translate(95.530342, 53.254010) rotate(-13.000000) translate(-95.530342, -53.254010) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-5)",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.332914,49.3000459 C108.646483,45.1990679 112.733143,40.27489 119.738847,37.6697592 C126.744551,35.0646284 132.123686,28.6432681 142.799288,28.6432681 C148.081748,28.6432681 153.740956,47.2337922 143.508616,52.8615593 C133.06188,58.6072437 106.669319,51.3717939 107.332914,49.3000459 Z",
    id: "Path-35",
    fill: "#575756",
    transform: "translate(128.261236, 41.838661) rotate(-13.000000) translate(-128.261236, -41.838661) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5946561,45.9786597 C48.6275313,47.9438609 51.226615,51.0977505 58.7518484,49.8350918 C66.2770818,48.5724331 65.6105635,41.8304007 76.6770832,40.9925409 C87.743603,40.1546811 95.8289255,38.5298314 90.1895763,31.732606 C86.4300102,27.2011224 83.8173858,25.6578 82.3517032,27.1026386 C58.491755,38.3765186 46.9060726,44.6685256 47.5946561,45.9786597 Z",
    id: "Path-34",
    fill: "#D9D9D9",
    transform: "translate(69.799882, 38.351814) rotate(-13.000000) translate(-69.799882, -38.351814) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.15168,14.0826653 C120.997619,13.0142113 108.413433,22.6302975 102.942788,24.0549029 C97.4721438,25.4795082 96.1600345,17.6945093 92.6133971,16.6260553 C89.0667596,15.5576013 95.6657096,25.7636005 100.682778,29.3015577 C105.699846,32.8395149 110.962849,31.3838982 118.193329,26.9041136 C123.01365,23.9175905 127.506057,22.2555509 131.670552,21.9179948 C128.760679,17.4067445 126.254388,14.794968 124.15168,14.0826653 Z",
    id: "Path-36",
    fill: "#D9D9D9",
    transform: "translate(111.639722, 22.639904) rotate(-13.000000) translate(-111.639722, -22.639904) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0279872,45.4159197 L53.1202113,46.4309409 C54.0377358,47.2836111 55.4727621,47.2310362 56.3254322,46.3135117 C56.7153422,45.8939451 56.9320611,45.3423863 56.9320611,44.7696159 L56.9320611,44.6427802 C56.9320611,43.1887487 58.1107866,42.0100232 59.5648181,42.0100232 C60.1079295,42.0100232 60.6377505,42.1779891 61.0816621,42.4908989 L61.4471749,42.7485459 C62.8317378,43.7245133 64.7453257,43.3932812 65.721293,42.0087183 C65.9580378,41.6728587 66.1248831,41.2928527 66.2119222,40.8912634 L66.4179936,39.9404721 C66.7768076,38.2849422 68.409756,37.2337464 70.0652859,37.5925604 C70.2642517,37.6356836 70.4584298,37.6985091 70.6449472,37.7801073 L71.7501298,38.263606 C73.0163937,38.8175751 74.4919841,38.240146 75.0459532,36.9738821 C75.2397661,36.5308641 75.3010805,36.0411834 75.2224816,35.5640559 C75.0240108,34.3592553 75.8398022,33.221679 77.0446028,33.0232081 C77.5409118,32.9414495 78.050264,33.031372 78.4885755,33.2781312 L82.06544,35.2918232 C82.7951532,35.7026348 83.7197313,35.444114 84.130543,34.7144008 C84.4444644,34.156791 84.3745298,33.4621288 83.9557605,32.978282 L81.4052762,30.0314479 L81.4052762,30.0314479",
    id: "Path-52",
    stroke: "#979797",
    strokeWidth: 1.53359996,
    strokeLinecap: "round",
    transform: "translate(68.527987, 38.531448) rotate(-13.000000) translate(-68.527987, -38.531448) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6605659,56.0314479 C11.3800034,58.8092257 13.3229181,69.126686 57.6624171,69.126686 C75.04484,69.126686 92.3159548,60.7933527 110.392619,60.7933527 C121.958032,60.7933527 134.887753,60.3974123 149.181783,59.6055316 L149.181783,59.6055228 C150.254733,59.546082 151.225886,60.2373889 151.520993,61.2706685 C153.863562,69.4728891 153.475051,74.4394453 150.355458,76.1703368 C145.349058,78.9481146 144.577391,81.0314479 121.996201,81.0314479 C110.979746,81.0314479 106.698149,78.5252766 91.0480732,78.5252766 C82.9108899,78.5252766 71.7003165,81.0314479 54.8716822,81.0314479 C5.67688512,81.0314479 9.33863883,57.8171622 10.6605659,56.0314479 Z",
    id: "Path-32",
    fill: "url(#linearGradient-6)",
    transform: "translate(81.527987, 68.531448) rotate(-13.000000) translate(-81.527987, -68.531448) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainerIcon);
export default __webpack_public_path__ + "static/media/trainer-icon.93a1029c729c1aef935d9990e552e723.svg";
export { ForwardRef as ReactComponent };